
import IMApp from "./IMApp";
import MessageType from "./IMMessageType";
import StringUtils from "./IMStringUtils";

export default class IMMessage {
    /** 二维数组 chatkey 为KEY  chat_msg 为值 */
    static messages = [];

    static removeMessage(chatKey, chatmsgno) {
        if (chatmsgno > 0) {
            let msgs = IMMessage.messages[chatKey];
            if (msgs && msgs.length > 0) {
                for (let i = 0; i < msgs.length; i++) {
                    if (msgs[i] && msgs[i].chatmsgno == chatmsgno) {
                        IMMessage.messages[chatKey].splice(i, 1);
                        break
                    }
                }
            }
        }
    }

    static getConversationMessageList(conversationId) {
        if (!IMMessage.messages[conversationId]) {
            return [];
        }
        let msgs = [];
        IMMessage.messages[conversationId].forEach(element => {
            msgs.push(element)
        });
        return msgs;
    }

    static setConversationMessageItem(conversationId, redBagId, type) {
        if (!IMMessage.messages[conversationId]) {
            return [];
        }
        IMMessage.messages[conversationId].forEach(element => {
            // addOrUpdateMessage

            if (element.msgtype == 5) {
                // redbag_id
                let content = element.content;
                content = JSON.parse(content);
                if (content.redbag_id == redBagId) {

                    content.type = type
                    element.content = JSON.stringify(content)
                    console.log(element);
                    IMMessage.addOrUpdateMessage(element)
                }


            }
        });
        // return msgs;
    }

    static isMessageExist(message) {
        if (message.chatmsgno == 0) {
            return false;
        }
        let exist = false;
        let allmessage = IMMessage.messages[message.chatkey];
        if (allmessage && allmessage.length > 0) {
            allmessage.forEach(element => {
                if (element.chatmsgno == message.chatmsgno) {
                    exist = true;
                }
            });
        }
        return exist;
    }

    static addOrUpdateMessage(message) {
        if (!IMMessage.messages[message.chatkey]) {
            IMMessage.messages[message.chatkey] = [];
        }
        if (message.chatmsgno > 0) {
            let isExits = false;
            let list = IMMessage.messages[message.chatkey];
            for (let i = 0; i < list.length; i++) {
                if (list[i].chatmsgno == message.chatmsgno) {
                    list[i] = message;
                    isExits = true;
                }
            }
            if (!isExits) {
                IMMessage.messages[message.chatkey].push(message)
            }
        } else {
            IMMessage.messages[message.chatkey].push(message)
        }
    }


    static getConversationLastMessage(conversationId) {
        let lastMessage = null;
        let allmessage = IMMessage.messages[conversationId];
        if (allmessage && allmessage.length > 0) {
            allmessage.forEach(element => {
                if (lastMessage == null) {
                    lastMessage = element
                } else {
                    if (element.chatmsgno > lastMessage.chatmsgno) {
                        lastMessage = element
                    }
                }
            });
        }
        return lastMessage;
    }

    static getConversationLastChatMsgNo(conversationId) {
        let lastMessage = IMMessage.getConversationLastMessage(conversationId);
        return lastMessage ? lastMessage.chatmsgno : 0;
    }

    static getChatMsgNo(conversationId) {
        let lastMessage = IMMessage.getConversationLastMessage(conversationId);
        return lastMessage ? lastMessage.chatmsgno + 1 : 0;
    }

    static getMessageDesc(lastMsg) {
        let lastMsgContent = '';
        if (lastMsg == null) {
            return '';
        } else if (lastMsg.msgtype == MessageType.TXT
            || lastMsg.msgtype == MessageType.CENTER_TIP
            || lastMsg.msgtype == MessageType.CENTER_TIP_ORDER) {
            lastMsgContent = lastMsg.content;
        } else if (lastMsg.msgtype == MessageType.IMAGE) {
            lastMsgContent = '[图片]';
        } else if (lastMsg.msgtype == MessageType.VIDEO) {
            lastMsgContent = '[视频]';
        } else if (lastMsg.msgtype == MessageType.VOICE) {
            lastMsgContent = '[语音]';
        } else if (lastMsg.msgtype == MessageType.REDBAG) {
            lastMsgContent = '[红包]';
        } else if (lastMsg.msgtype == MessageType.SHARE_LINK) {
            lastMsgContent = '[链接]';
        } else if (lastMsg.msgtype == MessageType.CARD) {
            lastMsgContent = '[名片]';
        } else if (lastMsg.msgtype == MessageType.CARD_GROUP) {
            lastMsgContent = '[群名片]';
        } else if (lastMsg.msgtype == MessageType.FILE) {
            lastMsgContent = '[文件]';
        } else if (lastMsg.msgtype == MessageType.GET_REDBAG) {
            let d = JSON.parse(lastMsg.content);
            if (d.recvuid == IMApp.user.uid) {
                if (d.senduid == IMApp.user.uid) {
                    lastMsgContent = '您领取了自己的红包';
                } else {
                    let username = IMApp.getShowNameByUID(d.senduid);
                    if (StringUtils.isEmpty(username)) {
                        username = d.sendname;
                    }
                    lastMsgContent = '您领取了' + (username ? StringUtils.adapterString(username, 20) + '的' : '') + '红包';
                }
            } else {
                if (d.senduid == IMApp.user.uid) {
                    lastMsgContent = d.recvname + '领取了您的红包';
                }
            }
        } else if (lastMsg.msgtype == MessageType.VOICE_CHAT || lastMsg.msgtype == MessageType.VOICE_CHAT1) {
            lastMsgContent = '[语音通话]';
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_CONFIRM) {
            try {
                let content = JSON.parse(lastMsg.content);
                let hoster = content.hoster;
                let users = content.users;
                lastMsgContent = "'" + StringUtils.adapterString(IMApp.getShowName(hoster, IMApp.conversationId), 4,) + "'想邀请" + users.length + '位朋友加入群聊';
            } catch (e) {
                lastMsgContent = lastMsg.content;
            }
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_QRCODE) {
            if (lastMsg.uid == IMApp.user.uid) {
                lastMsgContent = '您通过扫描二维码加入群聊';
            } else {
                let content = JSON.parse(lastMsg.content);
                if (content.uid == IMApp.user.uid) {
                    lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过扫描您分享的二维码加入群聊";
                } else {
                    lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过扫描'" + StringUtils.adapterString(content.username, 8) + "'分享的二维码加入群聊";
                }
            }
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_GROUP_CODE) {
            if (lastMsg.uid == IMApp.user.uid) {
                lastMsgContent = '您通过邀请链接加入群聊';
            } else {
                lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过邀请链接加入群聊";
            }
        } else if (lastMsg.msgtype == MessageType.AT) {
            let content = JSON.parse(lastMsg.content);
            lastMsgContent = content.content;
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_SCREENSHOT || lastMsg.msgtype == MessageType.CENTER_TIP_SCREENSHOT_OPEN) {
            lastMsgContent = IMApp.getText(lastMsg, lastMsg.chatkey);
        } else if (lastMsg.msgtype == MessageType.MONEY_LOG) {
            let content = JSON.parse(lastMsg.content);
            let title = '';
            let Amount_flag = content.amount > 0;
            if (content.moneytype == 1) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 2) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 3) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 4) {
                title = '到账通知';
            } else if (content.moneytype == 5) {
                title = '支付凭证';
            } else if (content.moneytype == 6) {
                title = '红包退款';
            } else if (content.moneytype == 7) {
                if (Amount_flag) {
                    title = '提现商户通知';
                } else {
                    title = '充值商户通知';
                }
            } else if (content.moneytype == 8) {
                title = '退款到账通知';
            } else if (content.moneytype == 9) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 11) {
                title = '支付凭证';
            }
            lastMsgContent = title;
        } else if (lastMsg.msgtype == MessageType.TRANSFER_ACCOUNTS || lastMsg.msgtype == MessageType.CENTER_TIP_TRANSFRT) {
            lastMsgContent = '[转账]';
        } else if (lastMsg.msgtype == MessageType.PROGRAME) {
            let content = JSON.parse(lastMsg.content);
            lastMsgContent = '[小程序]' + content.gamename;
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_NEED_VERFY) {
            lastMsgContent = '对方开启了朋友验证，您还不是ta的好友。请先发送朋友验证请求，对方验证通过后，才能聊天';
        } else if (!MessageType.checkIsSupport(lastMsg.msgtype)) {
            lastMsgContent = '收到一条当前版本不支持的消息，请升级版本';
        }

        if (lastMsg && lastMsg.isRecall) {
            let uid = lastMsg.uid;
            if (lastMsg.isRecallOther) {
                uid = lastMsg.recallID;
            }
            if (uid == IMApp.user.uid) {
                lastMsgContent = (lastMsg.isRecallOther ? '清除' : '撤回') + '了一条消息';
            } else {
                lastMsgContent = (lastMsg.isRecallOther ? '清除' : '撤回') + '了一条消息';
            }
        }



        if (lastMsgContent != '' && lastMsg.unreadCount > 1) {
            lastMsgContent = `[${lastMsg.unreadCount}条]` + lastMsgContent;
        }

        let inputMsg = IMApp.saveDocs[lastMsg.chatkey];
        if (!StringUtils.isEmpty(inputMsg)) {
            lastMsgContent = inputMsg;
        }

        if (lastMsg && IMApp.isSnap(lastMsg)) {
            lastMsgContent = '[阅后即焚]';
        }
        return lastMsgContent;
    }

}